module.exports = __webpack_public_path__ + "static/media/kfc-24-34.9187164b.jpg";